import { Component, Input, ViewChild } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import { ColumnsConfig, TableConfig, TableData } from 'sct-custom-table/sct-table/projects/sct-table/src/lib/custom-table-interface';
import { ModalComponent } from 'src/app/shared/modal/modal.component';
import { NotificationMessageService } from 'src/app/shared/notification-message/notification-message.service';
import { CommonService } from 'src/app/shared/services/common.service';
import { SideMenuService } from 'src/app/shared/side-menu/side-menu.service';
import { SitesService } from 'src/app/sites/sites.service';

@Component({
	selector: 'app-brm-potentially-malfunctioned-chargers',
	templateUrl: './brm-potentially-malfunctioned-chargers.component.html',
	styleUrls: ['./brm-potentially-malfunctioned-chargers.component.css']
})
export class BrmPotentiallyMalfunctionedChargersComponent {
	@ViewChild("removeDeviceModal") removeDeviceModal: ModalComponent;
	@Input() siteId: number;
	@Input() customerId: number;

	tableData: TableData[] = [];
	tableConfig: TableConfig = {
		hasExport: true,
		pageSize: 100,
		fileName: this.translateService.instant('admin.brm_potentially_malfunctioned_chargers'),
		tableHeight: 400,
		csvFileHeaderInfo: []
	};

	columnConfig: ColumnsConfig[] = [
		{ key: 'serial_number', name: this.translateService.instant('devices.serial_number'), type: "link"},
		{ key: 'truck_sn', name: this.translateService.instant('brmDevice.devices.truck_sn'), type: 'string' },
		{ key: 'truck_id', name: this.translateService.instant('brmDevice.devices.truck_id'), type: 'string'},
		{ key: 'current_idle_duration', name: this.translateService.instant('daily_details.idle_duration'), type: "duration"},
		{ key: 'remove', name: this.translateService.instant('potentially_malfunctioned.remove'), type: 'icon', }
	];
	toRemoveDevice: any;
	withCleared: boolean = false;
	siteInfo: any = {};
	siteSub: Subscription = new Subscription();

	constructor(
		private translateService: TranslateService,
		private siteService: SitesService,
		private commonService: CommonService,
		private notificationMessage: NotificationMessageService,
		private sideMenuService: SideMenuService
	) { }

	ngOnInit() {
		this.siteSub = this.sideMenuService.currentSite.subscribe((siteInfo:any) => {
			if (siteInfo) 
				this.siteInfo = siteInfo;
			this.loadPotentiallyMalfunctionedChargers();
		});
	}

	ngAfterViewInit() {
		this.removeDeviceModal.onClose.subscribe((ok) => {
			if(!ok)
				return;

			this.removeFromPotentiallyMalfunctionedCharger();
		});
	}

	loadPotentiallyMalfunctionedChargers() {
		const options = {
			withCleared: this.withCleared
		};

		this.siteService.getPotentiallyMalfunctionedChargers(this.siteId, options).subscribe((response: any) => {
			if (!response.length)
				return this.tableData = [];

			const existSerials = [];
			const tableData = [];
			for (let item of response || []) {
				if (!item.serial_number || existSerials.includes(item.serial_number))
					continue;

				existSerials.push(item.serial_number);
				tableData.push({
					mac_address: item.mac_address,
					serial_number: { value: item.serial_number, link: ['/', this.customerId, item.site_id, item.mac_address, 'performance'] },
					truck_sn: { value: item.charger_serial_number },
					truck_id: { value: item.charger_id },
					current_idle_duration: { value: this.commonService.longTimeFormat(item.event_duration), sortValue: item.event_duration },
					remove: { icon: 'window-close', action: () => this.openRemoveDeviceModal(item), iconColor: 'red' }
				});
			};

			this.tableData = tableData;
			this.tableConfig.csvFileHeaderInfo = this.commonService.getCsvFileHeadersInfo({customerName: this.siteInfo.customer_name, siteName: this.siteInfo.name, includeSpacing: false});
		});
	}

	openRemoveDeviceModal(device: any) {
		this.toRemoveDevice = device;
		this.removeDeviceModal.show();
	}

	removeFromPotentiallyMalfunctionedCharger() {
		this.siteService.unmarkMalfunctionedDevice(this.toRemoveDevice.mac_address, this.siteId ).subscribe((response: any) => {
			this.tableData = this.tableData.filter(item => item.mac_address !== this.toRemoveDevice.mac_address);
			this.toRemoveDevice = null;
			return this.notificationMessage.setMessage('globalSuccessMsg');
		});
	}

	toggleWithCleared() {
		this.loadPotentiallyMalfunctionedChargers();
	}

	ngOnDestroy() {
		if (this.siteSub)
			this.siteSub.unsubscribe();
	}
}
